<div class="login-bg d-flex align-items-center justify-content-center min-vh-100">

<div class="login-card mx-auto my-5 p-4 p-md-5 rounded-5 shadow-lg bg-white position-relative" style="width: 520px; max-width: 100%;">
  <div class="text-center mb-4 mt-2">
    <div style="font-weight:700;font-size:1.18rem;letter-spacing:1.2px;color:#253b6e;">
      <span style="color:#212e4e;">Perfect</span>
      <span style="color:#d1d8ee;">Learning</span>
      <span style="font-weight:400; color:#90a4cd; letter-spacing:0.7px; margin-left:5px;">Admin Portal</span>
    </div>
  </div>
  <!-- <h2 class="fw-bold text-center mb-2" style="color:#253b6e;">Sign in to your account</h2>
  <p class="text-muted text-center mb-4 small">Welcome back! Please enter your login details below.</p> -->
  <form (ngSubmit)="get()" autocomplete="off">
    <!-- Username Field -->
    <div class="mb-4 position-relative modern-input">
      <i class="fa fa-user input-icon"></i>
      <input
        type="text"
        class="form-control ps-5"
        [(ngModel)]="Username"
        name="username"
        required
        autocomplete="username"
        (keyup.enter)="get()"
        placeholder=" "
      />
      <label class="floating-label">User Name</label>
    </div>
    <!-- Password Field -->
    <div class="mb-4 position-relative modern-input">
      <i class="fa fa-lock input-icon"></i>
      <input
        [type]="showpassword1 ? 'text' : 'password'"
        class="form-control ps-5"
        [(ngModel)]="Password"
        name="password"
        required
        autocomplete="current-password"
        (keyup.enter)="get()"
        id="userPassword"
        placeholder=" "
      />
      <label class="floating-label">Password</label>
      <button type="button"
              class="showpass-btn"
              (mousedown)="showpassword1=true"
              (mouseup)="showpassword1=false"
              (mouseleave)="showpassword1=false"
              tabindex="-1"
              aria-label="Show/Hide password">
        <i class="fa" [ngClass]="showpassword1 ? 'fa-eye-slash' : 'fa-eye'"></i>
      </button>
    </div>
    <!-- Error Message -->
    <div *ngIf="loginError" class="alert alert-danger py-1 text-center small mb-2">
      Username or password not valid
    </div>
    <div *ngIf="loginEmptyError" class="alert alert-warning py-1 text-center small mb-2">
      Username or password should not be empty
    </div>
    <!-- Login Button -->
    <div class="d-grid mt-3 mb-2">
      <button type="submit" class="btn btn-primary btn-lg rounded-pill fw-semibold shadow-sm" style="background:#294d9a;border:none; padding:7px">
        Sign In
      </button>
    </div>
    <!-- <div class="text-end mb-2">
      <a href="#" class="text-decoration-none small text-muted">Forgot password?</a>
    </div> -->
  </form>
</div>
</div>
